import {
	AfterContentChecked,
	AfterContentInit,
	Component,
	ContentChild,
	ContentChildren,
	Directive,
	ElementRef,
	inject,
	Input,
	OnChanges,
	OnDestroy,
	QueryList,
} from "@angular/core";
import { fromEvent, merge, Observable, Subject } from "rxjs";
import { map, takeUntil } from "rxjs/operators";

@Directive({
	selector: "[icInput]",
	standalone: false,
})
export class InputFieldDirective implements OnChanges {
	private el = inject(ElementRef);

	@Input() placeholder: string;

	nativeElement = this.el.nativeElement;

	ngOnChanges(changes: any) {
		if (changes && changes.placeholder) {
			this.nativeElement.setAttribute("placeholder", this.placeholder);
		}
	}
}

@Directive({
	selector: "[icLabel]",
	standalone: false,
})
export class InputLabelDirective {}

@Directive({
	selector: "ic-error",
	standalone: false,
})
export class InputFieldErrorDirective {}

@Component({
	selector: "ic-form-field",
	templateUrl: "./form-field.component.html",
	styleUrls: ["./form-field.component.scss"],
	standalone: false,
})
export class FormFieldComponent implements AfterContentInit, AfterContentChecked, OnDestroy {
	@ContentChild(InputFieldDirective, { static: false }) child: InputFieldDirective;
	@ContentChild(InputLabelDirective, { static: false }) label: InputLabelDirective;
	@ContentChildren(InputFieldErrorDirective) errors: QueryList<InputFieldErrorDirective>;

	private onDestroy$ = new Subject<void>();

	focus$: Observable<boolean>;
	notEmpty$: Observable<boolean>;
	error$: Observable<boolean>;
	float: boolean;

	ngAfterContentInit() {
		const el = this.child.nativeElement;

		const focus$ = fromEvent(el, "focus");
		const blur$ = fromEvent(el, "blur");

		this.focus$ = merge(focus$.pipe(map(() => true)), blur$.pipe(map(() => false))).pipe(takeUntil(this.onDestroy$));

		this.error$ = this.errors.changes.pipe(
			takeUntil(this.onDestroy$),
			map((x) => x.length > 0),
		);

		this.notEmpty$ = merge(blur$.pipe(map(() => el.value !== ""))).pipe(takeUntil(this.onDestroy$));
	}

	ngAfterContentChecked() {
		const el = this.child.nativeElement;

		const hasValue = el.value !== "";
		const hasPlaceholder = Boolean(this.child.placeholder);
		this.float = Boolean(this.label && !hasValue && !hasPlaceholder);
	}

	ngOnDestroy() {
		this.onDestroy$.next();
	}
}
